<template>
	<div class='route_container'>
		<div class="main_container py-5 px-5 mt-5">
			<div class="row">
				<!-- category sidebar -->
				<div class="col-lg-3 filter-column pr-lg-3 px-0">
					<fancy-input
						:placeholder='`${ $t("gifts_search") }...`'
						v-model='searchGiveaway'
						type="text"
						aria-label="Search"
						ref="search"
						:large='true'
						:error='errors.search'
					></fancy-input>
					<ul id="filtersList" class="nav accordion d-flex flex-column flex-nowrap bg-gray-900 border border-green-lighter border-top-0  box-shadow my-3">
						<li class="nav-item py-3">
							<div class="d-flex row align-items-center justify-content-between m-0 px-2">
								<div class="categories-title d-flex row align-items-center col-11">
									<p class="h6 text-white mb-0 py-2">Category</p>
								</div>
							</div>
							<router-link
								v-for='(category, $index) in categories'
								:key='"category-link-" + $index'

								class='threads_main__side_bar__menu_item'
								:to='`/${$store.state.meta.lang}/giveaways/wishlist/search?price_max=` + category.value'
							>
								<span
									class='threads_main__side_bar__menu_item__border'
								></span>
								<span
									class='threads_main__side_bar__menu_item__text'
								>{{category.name}}</span>
							</router-link>
						</li>
					</ul>
				</div>
				<div class="col-lg-9 pl-lg-3 px-0 pb-3">
					<div class="border border-green-lighter pt-3 px-3">
						<h2 class="border-bottom border-green-lighter mr-3"> 
							{{ $t('gifts_giveaways') }} > {{ $t('gifts_whislist') }} 
						</h2>
						<div class="table">
							<div class="table__heading">
								<h6 class="table__column--width-small text-center"> {{ $t('gifts_rank') }} </h6>
								<h6 class="table__column--width-fill"> {{ $t('gifts_game') }} </h6>
								<h6 class="table__column--width-small text-center"> {{ $t('gifts_price') }} ( US$ )</h6>
								<h6 class="table__column--width-small text-center"> {{ $t('gifts_giveaways') }} </h6>
								<h6 class="table__column--width-small text-center"> {{ $t('gifts_trending') }} </h6>
							</div>
							<div v-if="loadWait" class="table__row-inner-wrap justify-content-center">								
								<loading-button									
									:loading='loadWait'
									class='nav-link'
								>
									<font-awesome-icon icon="spinner"/>
								</loading-button>
							</div>							
							<div class="table__row-inner-wrap" v-for="(row, $index) in drawWishLists.filter( x => x.game_price*1 <= ($route.query.price_max*1 || 9999) )" :key="$index">
								<div class="table__column--width-small text-center">
									{{$index+1}}
								</div>
								<div>									
									<div class="d-flex flex-row flex-wrap mx-0">
										<div class="game-card-rectangular" >
											<router-link :to="`/${$store.state.meta.lang}/giveaway/${row.creator}/${row.game_seo}/${row.giveaway_id}`" class="giveaway_image_thumbnail">
												<div class="d-flex flex-row">
													<div class="d-flex align-items-center justify-content-center position-relative">
														<div class="position-relative">
															<div class="overlay">
																<img class="logo-overlay card-img-overlay m-auto giveaway_image_thumbnail" :src="row.game_logo"  alt="--">
															</div>
															<div class="bg-img-container overflow-hidden box-shadow giveaway_image_thumbnail">
																<img class="gameCard-img" :src="row.game_banner" alt="...">
															</div>
														</div>
													</div>												
												</div>
											</router-link>
										</div>
									</div>
								</div>
								<div class="table__column--width-fill">
									<p>{{ decodeURI(row.game_name) }}</p>
									<a :href="`https://${$store.state.meta.lang}.idcgames.com/${row.game_seo}`" target="_blank">
										{{ decodeURI(`https://${$store.state.meta.lang}.idcgames.com/${row.game_seo}`) }}
									</a>
								</div>
								<div class="table__column--width-small text-center">
									{{ row.game_price || 0.00 }}
								</div>
								<div class="table__column--width-small text-center">
									{{ row.giveaway_cnt }}
								</div>
								<div class="table__column--width-small text-center">
									{{row.trending}}
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import FancyInput from '../FancyInput'
	import {apiDomain} from '../../config'
	import LoadingButton from '../LoadingButton';

	export default {
		name: 'wishlist',
		components: {
			FancyInput,
			LoadingButton
		},
		data () {
			return {
				choosed_color: "#00ff7f",
				choosed_back_color: "#00ff7f",
				categories: [
					{ "name": "All", "value": ""},
					{ "name": "$1.00 or less", "value": 1}, 
					{ "name": "$5.00 or less", "value": 5},
					{ "name": "$10.00 or less", "value": 10},
					{ "name": "$20.00 or less", "value": 20},
					{ "name": "$50.00 or less", "value": 50}
				],
				searchGiveaway: "",
				orgGiveaways: [],
				drawWishLists:[],
				loadWait: true,
				errors:{
					search: ''
				}
			}
		},
		watch: {
			searchGiveaway: function(skey){
				if(skey.length){
					this.drawWishLists = this.orgGiveaways.filter(x => x.game_name.toLowerCase().includes(skey.toLowerCase()) )
	
					this.drawWishLists.length ? this.errors.search = '' : (this.errors.search = this.$t("gifts_no_results"));
				}else{
					this.drawWishLists = this.orgGiveaways;
				}
			},
			'$route.query.price_max': function(val){
				// console.log(val);
			}
		},
		methods: {
			getUserWishlist: function(gwData){

				let oo = this;
				this.axios.post(`${apiDomain}/api/v1/userwishlist`, 
					{token: this.$cookies.get('token')}
				).then(res => {

					this.loadWait = false;
					
					let wishlists = res.data.data.map( x => { return x.id_idcgame } );

					oo.orgGiveaways = gwData.filter( x => wishlists.includes(x.idc_game_id*1) );
					oo.drawWishLists = oo.orgGiveaways;

				}).catch(err => {						
					console.log(err)
					this.$router.push('/');
				})
			}
		},
		mounted() {

			let oo = this;
			//all givesaways
			this.axios.request({
			method: 'GET',
			url: `${apiDomain}/api/v1/giveaways/all`
			}).then(res => {
				
				oo.getUserWishlist(res.data);				

			}).catch(err => {						
				this.$router.push('/');
			})			
		}
		
	}
</script>

<style lang='scss' scoped>
	@import '../../assets/scss/elementStyles.scss';
	@import '../../assets/scss/variables.scss';
	@import '../../assets/scss/idec.scss';

	.router-link-exact-active span:first-child {
		background-color: $color__green--primary;
	}

	.router-link-exact-active span:last-child {
		color: $color__green--primary;
	}

	.threads_main {
		display: flex;

		&__side_bar{
			width: 12rem;
			height: 0%;
			background: #fff;
			margin-right: 1rem;
			border-radius: 0.25rem;
			border: thin solid $color__gray--darker;
			padding: 0.5rem 0 1rem 1rem;
			position: sticky;
			top: 4.5rem;

			@at-root #{&}__title {
				color: $color__darkgray--darker;
				cursor: default;
				font-weight: 500;
				font-size: 1.125rem;
			}

			@at-root #{&}__menu_item {
				cursor: pointer;
				margin-top: 0.5rem;
				position: relative;
				display: grid;
				grid-template-columns: 0.75rem auto;
				grid-column-gap: 1rem;
				text-decoration: none;
				background-image: none;
				font-weight: normal;
				margin-left: 1.5rem;

				span{
					color: #fff;
				}

				@at-root #{&}__border {
					align-self: center;
					display: inline-block;
					height: 0.9rem;
					width: 0.9rem;
					border-radius: 0.5rem;
					margin-top: 0;
					background-color: $color__gray--darkest;
					transition: all 0.2s;
				}

				@at-root #{&}__text {
					filter: saturate(0.75), brightness(0.75);
				}


				@at-root #{&}--selected {
					font-weight: 600;
				}
			}
		}

		&__load_new{
			@extend .button;

			font-size: 1.25rem;
			margin: 0 0 1rem 0;
			background-color: $color__lightgray--primary;
			border-color: $color__gray--darker;
			width: 100%;
			font-weight: 300;
		}
	}

	.threads_main {
		display: flex;

		&__side_bar{
			width: 12rem;
			height: 0%;
			background: #fff;
			margin-right: 1rem;
			border-radius: 0.25rem;
			border: thin solid $color__gray--darker;
			padding: 0.5rem 0 1rem 1rem;
			position: sticky;
			top: 4.5rem;

			@at-root #{&}__title {
				color: $color__darkgray--darker;
				cursor: default;
				font-weight: 500;
				font-size: 1.125rem;
			}

			@at-root #{&}__menu_item {
				cursor: pointer;
				margin-top: 0.5rem;
				position: relative;
				display: grid;
				grid-template-columns: 0.75rem auto;
				grid-column-gap: 1rem;
				text-decoration: none;
				background-image: none;
				font-weight: normal;
				margin-left: 1.5rem;

				span{
					color: #fff;
				}

				@at-root #{&}__border {
					align-self: center;
					display: inline-block;
					height: 0.9rem;
					width: 0.9rem;
					border-radius: 0.5rem;
					margin-top: 0;
					background-color: $color__gray--darkest;
					transition: all 0.2s;
				}

				@at-root #{&}__text {
					filter: saturate(0.75), brightness(0.75);
				}


				@at-root #{&}--selected {
					font-weight: 600;
				}
			}
		}

		&__load_new{
			@extend .button;

			font-size: 1.25rem;
			margin: 0 0 1rem 0;
			background-color: $color__lightgray--primary;
			border-color: $color__gray--darker;
			width: 100%;
			font-weight: 300;
		}
	}

	.table{
		width: 100%;
		margin-bottom: 1rem;
		color: #212529;
		
		.table__heading {
			display: flex;
			min-height: 32px;
			align-items: center;
			font-size: 11px;
			margin-top: 1rem;
			margin-bottom: 1rem;
			font-weight: bold;
			color: #fff;
			border-bottom: 1px solid $color__green--darker;

			.table__column--width{

				&-fill{
					flex: 1;
				}
				&-small{
					width: 13%;
					min-width: 90px;
				}
				&-medium{
					width: 21%;
					min-width: 120px;
					display: flex;
					align-items: center;

					div{
						flex: 1;
					}
				}
			}
		}

		.table__row-inner-wrap{
			display: flex;
			align-items: center;
			line-height: 1.3em;
			color: #fff;
			padding: 10px 0;
			font-size: 14px;

			&:not(:last-child){
				border-bottom: 1px solid #d2d6e0;
			}

			.table__column--width{

				&-fill{
					flex: 1;
					margin-left: 15px;
				}
				&-small{
					width: 13%;
					min-width: 90px;

					svg{
						color: $color__green--darker;
					}
				}
				&-medium{
					width: 21%;
					min-width: 120px;
					display: flex;
					align-items: center;

					div{
						flex: 1;
					}
				}
			}
		}
		
	}

	@media (max-width: $breakpoint--tablet) {
		.main_container{
			margin-top: 0!important;			
			.table{
				overflow-x: auto;
				
				.table__row-inner-wrap, .table__heading{
					min-width: 800px;
				}
			}
		}
		.threads_main__side_bar {
			display: none;
		}
		.threads_main__threads {
			width: 100%;
			margin-left: 0;
		}
	}
</style>
